import styled from 'styled-components'
import { HeadingTitle } from '@components/PageHeading/PageHeading.styles'
import { textMuted } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'
import { Button } from '@components/Button'

// Styling shared by the flow's screens — heading, body, and the theme's control
// recipes — so they can't drift between steps.

/** The flow's controls sit on the theme recipes (see theme/recipes). */
export { actionButton, fieldStyles, flatButton } from '@/theme/recipes'

/** The section-page title's face (Files, Flights…), one notch down for a heading inside the card. */
export const Heading = styled(HeadingTitle)`
	font-size: ${fontSizes.heading};

	${media.phone} {
		font-size: ${fontSizes.title};
	}
`

export const Body = styled.p`
	margin: 8px 0 0;
	max-width: 560px;
	${text.bodyXs}
	line-height: ${leading.body};
	color: ${textMuted};
`

/** Text-style action ("Clear", "Back"): the Button's ghost variant without the vertical padding, so it sits inline. */
export const TextLinkButton = styled(Button).attrs({ variant: 'ghost' as const, size: 'sm' as const })`
	padding: 0 4px;
`
